import React from 'react';

import viewport$ from 'mn-utils/browser/emitters/viewport';
import withReDelay from 'mn-utils/withReDelay';
import formatTime from 'mn-utils/formatTime';

import Col from '../../../dumb/Col/D';
import IntervalFilter from '../../../dumb/IntervalFilter';
import {paramStore} from '../../../../stores';

import TableItem from './TableItem';
import Caption from '../../../dumb/Caption/C';
import ReportDownload from '../../../dumb/ReportDownload/B';
import UpdateA from '../../../dumb/Button/UpdateA';

const {
  INTERVAL_YEAR,
  getDateRange,
} = IntervalFilter;

const filter$ = paramStore('filter', {
  interval: INTERVAL_YEAR,
});

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
    viewport: viewport$.throttle(100),
  },
  rowHeight: 60,
  request: require('../../../../api/admin/transactions').apiV2TransactionsList,
  getParams: (self) => {
    const filter = self.state.filter;
    const {
      from,
      to,
    } = getDateRange(filter);

    const dateMask = '{yyyy}-{mm}-{dd}';

    return {
      search: filter.search || null,
      from: from && formatTime(from, dateMask),
      to: to && formatTime(to, dateMask),
      // from: from ? getRFC3339(from) : null,
      // to: to ? getRFC3339(to) : null,
      transaction_type: filter.transactionType || null,
      state: filter.state || null,
    };
  },
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    return (state) => {
      const filter = state.filter;
      const noData = !state.data || !state.data.count;

      return (
        <>
          <div className="layoutRow jcSB aiC">
            <Caption>Transactions</Caption>
            <div className="layoutRow">
              <UpdateA
                className="pl10"
                name="Update table"
                onClick={self.update}
              />
              <ReportDownload
                className="pl10"
                prefix="admin-transactions"
                urlPrefix="/f2c/v1/admin/payments/"
                filter={{...getDateRange(filter), state: filter.state}}
                disabled={noData}
              />
            </div>
          </div>
          <div className="mt22">
            <IntervalFilter
              className="mt24 (bgE8E8E8|bcA|c0)>.filter-btn.checked (bgE8E8E8:not[.disabled]:h)>.checked bg8>.search-field>.bg5B47FF "
              data={filter}
              onChange={handleChangeFilter}
              search={{placeholder: 'Search by ID / Email / Amount '}}
              disabledTransactionType
              // disabledSearch
              // disabledStatus
            />
            <div className="h100vh-300 rlv">
              <div className="abs sh sb10 st0 ov">
                <div className="abs s ovxA">
                  <div className="wmin1566 rlv h">
                    <div className="w abs bgE layoutRow fhaS fvaC r9 ov w1/9>1">
                      <Col>Transaction ID</Col>
                      <Col>Date and Time</Col>
                      <Col>Retailer</Col>
                      <Col>Customer</Col>
                      <Col>Payout Method</Col>
                      <Col>Amount (FIAT)</Col>
                      <Col>Amount (Crypto)</Col>
                      {/* <Col>PG Fee</Col>*/}
                      {/* <Col>Lunu Fee (PG)</Col>*/}
                      {/* <Col>Lunu Fee (RET)</Col>*/}
                      <Col>Transaction hash</Col>
                      <Col>Status</Col>
                    </div>
                    <div className="abs sh st45 sb c0>.CircularProgress">
                      {render(TableItem)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    };
  },
});
